import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  EecsAddWhiteListPayload,
  EecsDeleteWhiteListPayload,
  EecsUpdateWhiteListPayload,
  IEecsWhiteList,
} from '../types';

export const eecsWhiteListApi = createApi({
  reducerPath: 'eecsWhiteListApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/eecs/whitelist`),
  endpoints: (builder) => ({
    fetchWhiteLists: builder.query<ApiResponse<IEecsWhiteList[]>, any>({
      query: () => ({
        url: ``,
        method: 'GET',
      }),
    }),

    addWhiteList: builder.mutation<ApiResponse<IEecsWhiteList>, EecsAddWhiteListPayload>({
      query: (payload) => ({
        url: ``,
        method: 'POST',
        body: payload,
      }),
    }),

    updateWhiteList: builder.mutation<ApiResponse<IEecsWhiteList>, EecsUpdateWhiteListPayload>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),

    deleteWhiteList: builder.mutation<ApiResponse<any>, EecsDeleteWhiteListPayload>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyFetchWhiteListsQuery,
  useAddWhiteListMutation,
  useUpdateWhiteListMutation,
  useDeleteWhiteListMutation,
} = eecsWhiteListApi;
